/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum TimeOffStatus {
    PENDING = 'pending',
    ACCEPTED = 'accepted',
    REJECTED = 'rejected',
    CANCELLED = 'cancelled',
}